var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 5 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pud_svg__clip0_5255_43485)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.656 3.812a1.429 1.429 0 00-1.908-.035L3.637 9.929a1.429 1.429 0 00-.494 1.08v20.134h-1a1 1 0 00-1 1v1.428a1 1 0 001 1H39a1 1 0 001-1v-1.428a1 1 0 00-1-1h-1V4.857c0-.789-.64-1.428-1.429-1.428H22.857c-.789 0-1.428.64-1.428 1.428v26.286h-1.715V11.009c0-.396-.165-.775-.454-1.045l-6.604-6.152zm4.201 27.33h-3.143v-5.856a1 1 0 00-1-1h-2.571a1 1 0 00-1 1v5.857H6v-19.48l5.647-4.886 5.21 4.854v19.512zM35.143 6.287v24.857H32v-5.857a1 1 0 00-1-1h-2.572a1 1 0 00-1 1v5.857h-3.142V6.286h10.857zm-25 8a1 1 0 00-1 1v2.571a1 1 0 001 1h2.571a1 1 0 001-1v-2.571a1 1 0 00-1-1h-2.571zm17.285 3a1 1 0 011-1H31a1 1 0 011 1v2.571a1 1 0 01-1 1h-2.572a1 1 0 01-1-1v-2.571zm1-7.857a1 1 0 00-1 1V13a1 1 0 001 1H31a1 1 0 001-1v-2.571a1 1 0 00-1-1h-2.572z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pud_svg__clip0_5255_43485"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v39H0z"
  })))));
}

export default SvgPud;